module.exports = __webpack_public_path__ + "static/img/pic_email.a7b1fb51.png";